module.exports = fox._r("images/offer/acp/freeacp/bbw/overlay-big.jpg", __webpack_public_path__ + "_/_/_/root/images/offer/acp/freeacp/bbw/overlay-big.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/offer/acp/freeacp/bbw/overlay-big.jpg
// module id = 202
// module chunks = 4